//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectDisplayableObjectList.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AngleTolerance",1,0],[0,"DistanceTolerance",1,0],[1,"GridPlanes",0,"SelectDisplayableObjectList",0],[1,"Parts",0,"Assemblies.SelectComponentList",0],[0,"UseExistingCuttingSideFace",1,0]],[[["curve","numberPlacementFaces","placementFaces","numberTargetFaces","targetFaces"],"GetMarkingLineInformation",{},1,0],[["frecTag"],"IsMarkingLineFeature",{R_:{isMarkingLineFeature:''}},1,0]],[]];
SPLM.Features.ShipDesign.MarkingLineDesignBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.MarkingLineDesignBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;